export default __webpack_public_path__ + "static/media/web-app.9b2c52cd.png";